import axios from "axios";
// axios.defaults.baseURL = "/api/v1";

// const request = require('request-promise-native');

export default {
  auth: {
    login: async data => {
      try {
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v1/login/access-token`, `username=${data.username}&password=${data.password}`
        );
        if (response.data.access_token) {
          return { success: true, res: response.data };
        } else {
          return { success: false };
        }
       } catch(err) {
         console.log("err", err)
       }
       return {success: false};
    }
  },
  
  layers: {
    private: async data => {
      console.log("data: ", data)
      try {
        const response = await axios.patch(`${process.env.VUE_APP_BASE_URL}/api/v1/images/${data}`, 
        {
          status: "private"
        },{
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.token)}`
          },
        })
        if (response.data.success) {
          return { success: true };
        } else {
          return { success: false };
        }
      } catch(err) {
         console.log("err", err)
         return {success: false};
      } 
    },
    not_private: async data => {
      try {
        const response = await axios.patch(`${process.env.VUE_APP_BASE_URL}/api/v1/images/${data}`, 
        {
          status: "public"
        },{
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.token)}`
          },
        })
        if (response.data.success) {
          return { success: true };
        } else {
          return { success: false };
        }
      } catch(err) {
         console.log("err", err)
         return {success: false};
      }
    }
  }
};
